import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import {blue, grey} from '@mui/material/colors'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import * as React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {emToAbsoluteUrl} from 'utilities/extensionMethods'
import {websiteEndpoint} from '../../../config/apiConfig'

const pages = ['About', 'Pricing', 'Hypersonic']
const settings = ['Profile', 'Account', 'Dashboard', 'Logout']

function ResponsiveAppBar() {
  const navigate = useAppNavigate()
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }
  const handleNav = (page: string) => {
    handleCloseNavMenu()
    navigate(`/${page}`)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  return (
    <AppBar position='sticky' sx={{backgroundColor: '#181c32'}}>
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <Typography
            variant='h6'
            noWrap
            sx={{
              mr: 2,
              display: {xs: 'none', md: 'flex'},
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <RouterLink to='/'>
              <Box mr={5}>
                <img
                  alt='Logo'
                  style={{
                    height: '28px',
                    width: 'auto',
                    verticalAlign: 'middle',
                    overflow: 'clip',
                  }}
                  src={emToAbsoluteUrl('/static/logos/iScoutHorizontalWhite_20k.png')}
                />
              </Box>
            </RouterLink>
          </Typography>

          <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: {xs: 'block', md: 'none'},
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={() => handleNav(page)}>
                  <Typography textAlign='center'>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant='h5'
            noWrap
            sx={{
              mr: 2,
              display: {xs: 'flex', md: 'none'},
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <RouterLink to='/'>
              <Box mr={5}>
                <img
                  alt='Logo'
                  className='h-25px logo'
                  src={emToAbsoluteUrl('/static/logos/iScoutHorizontalWhite.png')}
                />
              </Box>
            </RouterLink>
          </Typography>
          <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => handleNav(page)}
                sx={{my: 2, color: 'white', display: 'block'}}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box sx={{flexGrow: 0}}>
            <Link
              href={websiteEndpoint('signup')}
              color={'info'}
              variant={'button'}
              underline={'none'}
              sx={{
                backgroundColor: grey[100],
                p: '10px 15px 10px 15px',
                borderRadius: '5px',
                color: grey[900],
                marginRight: 2,
                '&:hover': {
                  color: grey[700],
                  backgroundColor: grey[50],
                },
              }}
            >
              Signup
            </Link>
            <Link
              href={websiteEndpoint('loading')}
              color={'primary'}
              variant={'button'}
              underline={'none'}
              sx={{
                backgroundColor: blue[500],
                p: '10px 15px 10px 15px',
                borderRadius: '5px',
                color: grey[100],
              }}
            >
              Log In
            </Link>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default ResponsiveAppBar
